import { Pages } from '@context/useMyRouting';
import useMyRouting from '@context/useMyRouting/useMyRouting';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import React, { FC } from 'react';

export interface BreadCrumbProps {
  id: number | string;
  name: string;
  isRedirect?: boolean;
  url?: string;
}

interface Props {
  crumbs: BreadCrumbProps[];
}

/** *
 * Компонент вывода хлебных крошек
 */
const BreadCrumbsHOC: FC<Props> = ({ crumbs }) => {
  const { setPage } = useMyRouting().actions;

  const handleClick = (url: string, isRedirect: boolean) => {
    if (isRedirect) {
      window.open(url, '_self');
      return;
    }

    url === 'widget' && window.open('/online-logistics', '_self');
    setPage(url as Pages);
  };

  const breadcrumbsData = crumbs.map((item, index) =>
    item.url ? (
      <div
        style={{ cursor: 'pointer' }}
        onClick={() => handleClick(item.url, item.isRedirect)}
        key={index}
      >
        {item.name}
      </div>
    ) : (
      <Typography variant={'body1'} key={index}>
        {item.name}
      </Typography>
    )
  );

  return (
    <Breadcrumbs
      className={'breadcrumbs'}
      color={'grey.800'}
      separator={<ArrowForwardIosIcon sx={{ color: 'grey.800', fontSize: 12 }} />}
    >
      {breadcrumbsData}
    </Breadcrumbs>
  );
};

export default BreadCrumbsHOC;
